// Enum for sidebar mode.
export enum ESidebarMode {
	Appointments,
	Details,
	Edit,
	New,
	AppointmentDetails,
}
